// src/redux/actions/engagementActions.ts
import { createAction } from '@reduxjs/toolkit';

// Action types
export const CREATE_ENGAGEMENT = 'CREATE_ENGAGEMENT';
export const CREATE_ENGAGEMENT_SUCCESS = 'CREATE_ENGAGEMENT_SUCCESS';
export const CREATE_ENGAGEMENT_ERROR = 'CREATE_ENGAGEMENT_ERROR';

// Action creators
export const createEngagement = createAction<any>(CREATE_ENGAGEMENT);
export const createEngagementSuccess = createAction<any>(CREATE_ENGAGEMENT_SUCCESS);
export const createEngagementError = createAction<any>(CREATE_ENGAGEMENT_ERROR);
